import { RequestState, RowNew } from '../components/Table/types';
import { useParties } from '../contexts/PartiesContext';

export const useCustomSort = (rows: RowNew[]) => {
  const { party } = useParties();

  return rows.sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);

    // ensures that receving items will always be at the top
    // Users need to action accept / reject
    if (
      b.receiver === party &&
      (b.requestState === RequestState.Requested || b.requestState === RequestState.Offered)
    ) {
      return 1;
    }
    if (dateA < dateB) {
      return 1;
    }
    if (dateA > dateB) {
      return -1;
    }
    return 0;
  });
};
